import React from 'react';
import './Loader.scss';
const CommonLoader = () => {
    return (
        <div className="common-loader">
            <div className="common-loader_overlay" />
            <img src="//static.lenskart.com/media/desktop/img/loader-lk.gif" alt="Loading" title="Loading" />
        </div>
    );
};

export default CommonLoader;
